import * as React from "react";

function Archive(props) {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 18.6235C1.45 18.6235 0.979 18.4279 0.587 18.0365C0.195667 17.6445 0 17.1735 0 16.6235V4.12354C0 3.87354 0.0416667 3.64854 0.125 3.44853C0.208333 3.24853 0.316667 3.05687 0.45 2.87354L1.85 1.17354C1.98333 0.990202 2.15 0.852535 2.35 0.760535C2.55 0.669202 2.76667 0.623535 3 0.623535H15C15.2333 0.623535 15.45 0.669202 15.65 0.760535C15.85 0.852535 16.0167 0.990202 16.15 1.17354L17.55 2.87354C17.6833 3.05687 17.7917 3.24853 17.875 3.44853C17.9583 3.64854 18 3.87354 18 4.12354V16.6235C18 17.1735 17.8043 17.6445 17.413 18.0365C17.021 18.4279 16.55 18.6235 16 18.6235H2ZM2.4 3.62354H15.6L14.75 2.62354H3.25L2.4 3.62354ZM2 5.62354V16.6235H16V5.62354H2ZM9 15.6235L13 11.6235L11.6 10.2235L10 11.8235V7.62354H8V11.8235L6.4 10.2235L5 11.6235L9 15.6235ZM2 16.6235H16H2Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoArchive = React.memo(Archive);
export default MemoArchive;
